import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-menu" };
const _hoisted_4 = { class: "float-end" };
const _hoisted_5 = { class: "form-contents" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "clearfix" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "input-group-btn" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12" };
const _hoisted_12 = { class: "card bg-white data-grid detached overflow-x-auto" };
const _hoisted_13 = { class: "table table-hover bottom0 pw100" };
const _hoisted_14 = { class: "min-width300" };
const _hoisted_15 = { class: "invalid-feedback" };
const _hoisted_16 = { class: "min-width100" };
const _hoisted_17 = { class: "min-width100" };
const _hoisted_18 = { class: "min-width150" };
const _hoisted_19 = { class: "invalid-feedback" };
const _hoisted_20 = { class: "min-width150" };
const _hoisted_21 = { class: "w50 min-width50" };
const _hoisted_22 = { class: "invalid-feedback" };
const _hoisted_23 = { class: "w50 min-width50" };
const _hoisted_24 = { class: "w50 min-width50 text-end" };
const _hoisted_25 = { class: "w50 min-width50 text-end" };
const _hoisted_26 = { class: "min-width100 text-end" };
const _hoisted_27 = { key: 0 };
const _hoisted_28 = { class: "data-grid-footer clearfix detached pw100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_select = _resolveComponent("b-form-select");
    const _component_b_pagination = _resolveComponent("b-pagination");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tMeasurement Types\r\n\t\t\t\t")
            ], -1 /* CACHED */)),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_b_button, {
                        variant: "primary",
                        onClick: _ctx.add
                    }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Add Measurement Type", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _cache[29] || (_cache[29] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_10, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[6] || (_cache[6] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ])
                ]),
                _cache[28] || (_cache[28] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("table", _hoisted_13, [
                            _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\tMeasurement\r\n\t\t\t\t\t\t\t\t\t"),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\tComponent\r\n\t\t\t\t\t\t\t\t\t"),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\tCategory\r\n\t\t\t\t\t\t\t\t\t"),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tUoM"),
                                        _createElementVNode("br"),
                                        _createTextVNode("(Metric)\r\n\t\t\t\t\t\t\t\t\t")
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tUoM"),
                                        _createElementVNode("br"),
                                        _createTextVNode("(Imperial)\r\n\t\t\t\t\t\t\t\t\t")
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tUoM Code"),
                                        _createElementVNode("br"),
                                        _createTextVNode("(Metric)\r\n\t\t\t\t\t\t\t\t\t")
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tUoM Code"),
                                        _createElementVNode("br"),
                                        _createTextVNode("(Imperial)\r\n\t\t\t\t\t\t\t\t\t")
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", { class: "text-end" }, "\r\n\t\t\t\t\t\t\t\t\t\tMetric to Imperial Multiplier\r\n\t\t\t\t\t\t\t\t\t"),
                                    _createTextVNode(),
                                    _createElementVNode("th", { class: "text-end" }, "\r\n\t\t\t\t\t\t\t\t\t\tMetric to Imperial Sum Factor\r\n\t\t\t\t\t\t\t\t\t"),
                                    _createTextVNode(),
                                    _createElementVNode("th", { class: "w100" })
                                ])
                            ], -1 /* CACHED */)),
                            _cache[25] || (_cache[25] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", _hoisted_14, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.measurementTypeName,
                                                "onUpdate:modelValue": ($event) => ((item.measurementTypeName) = $event),
                                                modelModifiers: { trim: true },
                                                class: _normalizeClass({ 'is-invalid': !item.measurementTypeName }),
                                                maxlength: "150"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "class"]),
                                            _cache[8] || (_cache[8] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_15, "\r\n\t\t\t\t\t\t\t\t\t\t\tThe Measurement Type field is required.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, !item.measurementTypeName]
                                            ])
                                        ]),
                                        _cache[14] || (_cache[14] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_16, [
                                            _createVNode(_component_b_form_select, {
                                                modelValue: item.componentTypeId,
                                                "onUpdate:modelValue": ($event) => ((item.componentTypeId) = $event),
                                                options: _ctx.componentTypes
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"])
                                        ]),
                                        _cache[15] || (_cache[15] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_17, [
                                            _createVNode(_component_b_form_select, {
                                                modelValue: item.measurementCategoryId,
                                                "onUpdate:modelValue": ($event) => ((item.measurementCategoryId) = $event),
                                                options: _ctx.measurementCategories
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"])
                                        ]),
                                        _cache[16] || (_cache[16] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_18, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.unitOfMeasurement,
                                                "onUpdate:modelValue": ($event) => ((item.unitOfMeasurement) = $event),
                                                modelModifiers: { trim: true },
                                                class: _normalizeClass({ 'is-invalid': !item.unitOfMeasurement }),
                                                maxlength: "150"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "class"]),
                                            _cache[9] || (_cache[9] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_19, "\r\n\t\t\t\t\t\t\t\t\t\t\tThe Unit of Measurement field is required.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, !item.unitOfMeasurement]
                                            ])
                                        ]),
                                        _cache[17] || (_cache[17] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_20, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.unitOfMeasurementImperial,
                                                "onUpdate:modelValue": ($event) => ((item.unitOfMeasurementImperial) = $event),
                                                modelModifiers: { trim: true },
                                                maxlength: "150"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _cache[18] || (_cache[18] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_21, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.unitOfMeasurementCode,
                                                "onUpdate:modelValue": ($event) => ((item.unitOfMeasurementCode) = $event),
                                                modelModifiers: { trim: true },
                                                class: _normalizeClass({ 'is-invalid': !item.unitOfMeasurementCode }),
                                                maxlength: "150"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "class"]),
                                            _cache[10] || (_cache[10] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_22, "\r\n\t\t\t\t\t\t\t\t\t\t\tThe Unit of Measurement Code field is required.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, !item.unitOfMeasurementCode]
                                            ])
                                        ]),
                                        _cache[19] || (_cache[19] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_23, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.unitOfMeasurementCodeImperial,
                                                "onUpdate:modelValue": ($event) => ((item.unitOfMeasurementCodeImperial) = $event),
                                                modelModifiers: { trim: true },
                                                maxlength: "150"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _cache[20] || (_cache[20] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_24, [
                                            _createVNode(_component_b_form_input, {
                                                type: "number",
                                                modelValue: item.conversionFactor,
                                                "onUpdate:modelValue": ($event) => ((item.conversionFactor) = $event),
                                                modelModifiers: { trim: true },
                                                maxlength: "10"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _cache[21] || (_cache[21] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_25, [
                                            _createVNode(_component_b_form_input, {
                                                type: "number",
                                                modelValue: item.conversionAdditionalFactor,
                                                "onUpdate:modelValue": ($event) => ((item.conversionAdditionalFactor) = $event),
                                                modelModifiers: { trim: true },
                                                maxlength: "10"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _cache[22] || (_cache[22] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_26, [
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: ($event) => (_ctx.save(item))
                                            }, {
                                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                        _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"]),
                                            _cache[13] || (_cache[13] = _createTextVNode()),
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: ($event) => (_ctx.purge(item))
                                            }, {
                                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"])
                                        ])
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[26] || (_cache[26] = _createTextVNode()),
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_27, [...(_cache[23] || (_cache[23] = [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "10"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ])
                                        ], -1 /* CACHED */)
                                    ]))]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _cache[27] || (_cache[27] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_b_pagination, {
                            class: "float-end",
                            modelValue: _ctx.query.pageNo,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.pageNo) = $event)),
                            "per-page": _ctx.query.pageSize,
                            "total-rows": _ctx.data.recordCount,
                            "hide-ellipsis": true,
                            disabled: _ctx.working
                        }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
